module.exports = __webpack_public_path__ + "static/media/auth-partner-logos.8f7df4ec.png";